import { useTranslations } from 'next-intl';
import React, { type ReactNode } from 'react';
import { type SubscriptionPlanFeaturesT } from '@mentimeter/http-clients';
import { type GetInvitesResponse } from '@core-api/workspace-members/workspace-members/invites/{token}';
import { Strong } from '@mentimeter/ragnar-ui/typography';
import { BulletWrapper, Intro } from './_utils';
import { PlansName } from './utils';

const StrongText = (children: ReactNode) => Strong({ children });

export const JoinTeamConsentPaidUserContent = ({
  email,
  currentPlan,
  newPlan,
}: {
  email: string;
  currentPlan: SubscriptionPlanFeaturesT;
  newPlan: GetInvitesResponse['workspacePlanFeatures'];
}) => {
  const t = useTranslations('onboarding.join_workspace');
  const currentPlanName = PlansName[currentPlan];

  return (
    <>
      <Intro email={email} />
      <BulletWrapper>
        {t.rich('join_subscription_message', {
          planName: PlansName[newPlan],
          StrongText,
        })}
      </BulletWrapper>
      <BulletWrapper>
        {t.rich('cancel_current_subscription_message', {
          currentPlanName,
          StrongText,
        })}
      </BulletWrapper>
      <BulletWrapper>
        {t.rich('keep_presentations_message', {
          StrongText,
        })}
      </BulletWrapper>
    </>
  );
};
